import {TimeCompareRequest} from 'src/modules/platform-alert-builder/typedef';

import {Integer} from '@pb/kit-component-formatters';

import {COLUMNS, HEADERS} from './all-alerts/constants';

import type {Locale} from '@pb/kit-context-locale';

export const getHeader = (locale: Locale, totalCount?: number) => {
    const caption = HEADERS[COLUMNS.ALERT_MESSAGE];
    if (totalCount) {
        return caption + (totalCount ? ` (${Integer.format(totalCount, locale)})` : '');
    }

    return caption;
};

export const extractTextFromHTML = (htmlString: string) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
    return doc.body.textContent || '';
};

const timeToMinutes = (time: string): number => {
    const [hours, minutes] = time.split(':').map(Number);
    return hours * 60 + minutes;
};

export const isEndTimeBeforeStartTime = ({startDate, endDate, startTime, endTime}:
TimeCompareRequest): boolean => {
    return startDate === endDate && timeToMinutes(endTime) < timeToMinutes(startTime);
};
